/* @ngInject */
export default function DefinitionController($scope, $rootScope, $location, $timeout, CacheService, ContainerInfoApiService) {
    // If the definitions are already in the cache, grab them out. We don't handle an else case, because all of the
    // view controllers already handle a redirect.
    if (CacheService.getAllDefinitions()) {
        $scope.definitions = CacheService.getAllDefinitions();
    }

    $scope.traverseUsingTree = function (definition, siblings) {
        siblings.forEach(function (sibling) {
            if (definition.id !== sibling.id) {
                sibling.setActiveClass = false;
                sibling.showParameters = false;
            }
        });

        definition.setActiveClass = true;
        definition.showParameters = true;
        CacheService.storeDefinition(definition);

        $timeout(
            function () {
                $scope.$apply(function () {
                    $location.path('/browsing').search('id', definition.id);
                });
            },
            10
        );
    };

    $scope.displayName = function (definition) {
        if (CacheService.getConfigurationInfo() !== undefined) {
            return ContainerInfoApiService.getDisplayName(definition, CacheService.getConfigurationInfo().language);
        } else {
            return ContainerInfoApiService.getDisplayName(definition, 'ENGLISH');
        }
    };
}
